export default {
  BackgroundSettings: "Background Settings",
  ResetValues: "Reset Values",
  BackgroundSigmaSpace: "Sample Distance",
  CoverageMin: "Minimum Coverage",
  CoverageMax: "Maximum Coverage",
  LightWrapping: "Edge Brightness",
};
